import { closeSnackbar, enqueueSnackbar, SnackbarKey } from 'notistack';
import { useTranslation } from 'react-i18next';
import config from '../../../../../config';
import ActivityChangeContent from '../Components/ActivityChangeContent';
import renderActivityChangeAction from '../Components/renderActivityChangeAction';

export default function useEnqueueTrigger() {
  const { t } = useTranslation('notifications');
  function enqueueTrigger(key: 'activityChange' | 'sessionTimeout', subkey: string, callback: () => void) {
    let snackbarKey: SnackbarKey | null = null;
    const autoHideDuration: number = config.Live.Audio[key][subkey];
    const timeout = setTimeout(() => {
      callback();
      if (snackbarKey) {
        closeSnackbar(snackbarKey);
      }
    }, autoHideDuration);

    snackbarKey = enqueueSnackbar(
      ActivityChangeContent({ duration: autoHideDuration, title: t(`${key}.${subkey}.title`), body: t(`${key}.${subkey}.body`) }),
      {
        variant: 'info',
        autoHideDuration,
        action: renderActivityChangeAction(
          () => {
            clearTimeout(timeout);
          },
          t(`${key}.${subkey}.keep`),
        ),
        hideIconVariant: true,
        style: {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
        },
      },
    );
  }

  return enqueueTrigger;
}
